(() => {
  const descriptions = document.querySelectorAll('.nb-product-description[data-match-info-height="true"]');

  descriptions.forEach((description) => {
    const product = description.closest('[data-section-type="product"]');
    const infoCard = product?.querySelector('.product-block-list__item--info > .card');
    const descriptionCard = description.closest('.card');
    const descriptionHeader = descriptionCard?.querySelector('.card__header');
    if (!infoCard || !descriptionCard) return;

    const matchHeight = () => {
      if (!window.matchMedia('(min-width: 1000px)').matches) {
        description.style.removeProperty('--nb-description-matched-height');
        return;
      }

      const availableHeight = Math.max(240, infoCard.getBoundingClientRect().height - (descriptionHeader?.getBoundingClientRect().height || 0));
      description.style.setProperty('--nb-description-matched-height', `${Math.round(availableHeight)}px`);
    };

    matchHeight();
    window.addEventListener('resize', matchHeight, { passive: true });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(matchHeight);
      observer.observe(infoCard);
    }
  });
})();
